import React, { useEffect, useState } from 'react';
// import GeneralNavbar from '../../Header';
import GeneralNavbar from '../Header';
import Footer from '../Footer';
import '../css/presale.css'
import '../css/contactus.css'
import Banner from '../Presale/Banner'
import { Fade, Zoom } from 'react-reveal';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import { FaRegEnvelope } from "react-icons/fa";
import { LiaAddressCardSolid, LiaLocationArrowSolid, LiaPhoneSolid } from "react-icons/lia";
import { CiMail } from "react-icons/ci";
import Community from '../../community';
// import { Header } from 'antd/es/layout/layout';
import Header from '../../Header';


const Contactus = () => {

    return (
        <>
            <Header />

            <section className='contactus_sec'>
                <div className='contactbackImg-block'>
                    <img src='assets/images/contactbackImg.png' alt='contactbackImg' className='contactbackImg' />
                    {/* <div> */}
                    <h1 className='text-primary fw-bold fs-1'>Contact With US</h1>
                    {/* </div> */}
                </div>
                <Container>
                    <Row className='' >
                        <Col lg={12} className='py-5'>
                            <div className='contact-details p-lg-5 p-md-5 p-3'>
                                <Row>
                                    <Col lg={6} className='mb-3'>
                                        <Form>
                                            <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
                                                <Form.Control type="text" placeholder="Your Name" />
                                            </Form.Group>
                                            <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
                                                <Form.Control type="email" placeholder="Email Address" />
                                            </Form.Group>
                                            <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
                                                <Form.Control type="text" placeholder="Subject" />
                                            </Form.Group>
                                            <Form.Group className="mb-4" controlId="exampleForm.ControlTextarea1">
                                                <Form.Control as="textarea" rows={6} placeholder='Message' />
                                            </Form.Group>
                                            <Button variant='custombtn2' className='py-2  fs-4 w-100 fw-bold' style={{ letterSpacing: "1.1px" }}>
                                                SUBMIT
                                            </Button>
                                        </Form>
                                    </Col>
                                    <Col lg={6} className='mb-3'>
                                        <Card className='px-lg-5 px-md-5 px-3 pt-3 pb-3 getincard' style={{ background: "url(assets/images/contactus/getinback.png), #93d9ac30", backgroundSize: "100%" }}>
                                            <div>
                                                <h4>Get in Touch</h4>
                                                <p className='text-primary fs-5'>Want to get in touch? We'd love to hear from you.</p>
                                            </div>
                                            <div className='gettouch-block'>
                                                <ul className='mb-0 list-group lh-1'>
                                                    <li className='list-group-item bg-transparent border-0 p-0 mb-4'><p className='mb-0 text-primary fs-4'>Our Location: </p></li>
                                                    <li className='list-group-item bg-transparent border-0 p-0'><LiaAddressCardSolid className='mailIcon me-2' />&nbsp;<small className='text-primary'>INFI MultiChain CDEX Exchange powerd by Inverted Investment LLC 66 W Flagler Street, Suite 900 PMB 10673 Miami, FL 33130, USA.</small></li>
                                                    <p></p>
                                                    <li className='list-group-item bg-transparent border-0 p-0 mb-3'><CiMail className='mailIcon me-2' />&nbsp;<small className='text-primary text-decoration-underline'>support@infimultichain.com</small></li>
                                                </ul>
                                            </div>
                                            {/* <div className='gettouch-block mb-0'>
                                                <ul className='mb-0 list-group lh-1'>
                                                    <li className='list-group-item bg-transparent border-0 p-0 mb-4'><p className='mb-0 text-primary fs-4'>For Career :</p></li>
                                                    <li className='list-group-item bg-transparent border-0 p-0 mb-3'><CiMail className='mailIcon me-2' />&nbsp;<small className='text-primary text-decoration-underline'>support@infimultichain.com</small></li>
                                                    <li className='list-group-item bg-transparent border-0 p-0'><LiaPhoneSolid className='mailIcon me-2' />&nbsp;<small className='text-primary'>+91-999999999</small></li>
                                                </ul>
                                            </div> */}
                                            {/* <div className='my-3'>
                                                <a href="#" className='infilink text-primary'>https://calendly.com/infimultichain</a>
                                            </div> */}
                                            <div class="mb-4">
                                                <p>
                                                <Button variant='dark' onClick={(e) => {
                                                    e.preventDefault()
                                                    window.open("https://calendly.com/infimultichain-support/30min", "_blank")
                                                }}>Book a call with us</Button>
                                                </p>
                                                </div>
                                            </Card>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


            <Community />

            <Footer />
        </>
    )
}

export default Contactus
